<template>
    <div v-if="Boolean(title)" :color="color" dense class="toolbox-header">
        <button class="btn-icon icon-close" @click="closeDialog" :disabled="loading"></button>
        <h2>{{ title }}</h2>
    </div>
</template>

<script>
  import { VIcon, VToolbarTitle } from 'vuetify/lib'

  export default {
    components: {
      VToolbarTitle,
      VIcon
    },
    methods: {
      closeDialog () {
        this.$emit('canceled')
      }
    },
    props: {
      loading: {
        type: Boolean,
        default: () => false
      },
      color: {
        type: String,
        default: 'info'
      },
      icon: {
        type: String,
        default: 'info'
      },
      title: {
        type: String
      }
    }
  }
</script>

<style scoped></style>
